<div class="overlay intercom-page" >
  <img loading="lazy" class="loader1" src="assets/images/loader-gif.gif" alt="1Loader">
</div>
